import moment from 'moment';
import { Box, Flex } from 'reflexbox';
import { Avatar } from './Avatar';
import { Skeleton } from './Skeleton';
import { Paragraph } from './Text';

import { Link } from '@treams/treams-routes';

import * as graphql from '../../../../src/generated/graphql';

export const Author = Skeleton(
	function Author(props: { user: graphql.User; createdAt: Date; description: string }) {
		return (
			<Link to={`/users/${props.user.id}`}>
				<Flex alignItems="center">
					<Avatar user={props.user} size={40} mr={2} />
					<Box>
						<Paragraph mb={1}>
							{props.user.firstName} {props.user.lastName}
						</Paragraph>
						<Paragraph>
							{props.description}: {moment(props.createdAt).format('D MMM YYYY')}
						</Paragraph>
					</Box>
				</Flex>
			</Link>
		);
	},
	function GoalAuthorSkeleton() {
		return (
			<Flex alignItems="center">
				<Avatar.Skeleton size={40} mr={2} />
				<Box>
					<Paragraph.Skeleton lines={1} mb={1} />
					<Paragraph.Skeleton lines={1} />
				</Box>
			</Flex>
		);
	},
);
